export default __webpack_public_path__ + "static/runway-02-555d19d04c1a8ef4b84277a7f3eeea93.mp4";